import React from 'react';
import * as S from './SeparatorLineBlock.styles';

export const SeparatorLineBlock = () => <S.SeparatorLine />;

export const SeparatorLineBlockSerializer = () => () => <SeparatorLineBlock />;
